import * as XLSX from 'xlsx';
import type { Item, StockUnit } from '../store/inventoryStore';

export const INVENTORY_TEMPLATE_HEADERS = ['Item Name', 'SKU', 'Category', 'Notes'] as const;
export const INVENTORY_EXPORT_HEADERS = [...INVENTORY_TEMPLATE_HEADERS, 'Stock Count'] as const;
export const INVENTORY_UNITS_TEMPLATE_HEADERS = [
  'Item Name',
  'SKU',
  'Category',
  'Serial/MAC',
  'Warehouse',
  'Storage Area',
  'New/Used',
  'Status',
  'Reference',
  'Owner',
  'Notes',
] as const;

const TEMPLATE_COLS = [{ wch: 24 }, { wch: 16 }, { wch: 18 }, { wch: 30 }];
const EXPORT_COLS = [...TEMPLATE_COLS, { wch: 14 }];
const UNITS_TEMPLATE_COLS = [
  { wch: 24 },
  { wch: 16 },
  { wch: 16 },
  { wch: 18 },
  { wch: 16 },
  { wch: 16 },
  { wch: 12 },
  { wch: 14 },
  { wch: 16 },
  { wch: 16 },
  { wch: 24 },
];

export function downloadInventoryTemplate() {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([
    [...INVENTORY_TEMPLATE_HEADERS],
    ['Litebeam AC', 'LB-AC-001', 'CPE Radio', ''],
    ['LTU-LR', 'LTU-LR-001', 'CPE Radio', 'Long range'],
  ]);
  ws['!cols'] = TEMPLATE_COLS;
  XLSX.utils.book_append_sheet(wb, ws, 'Items');
  XLSX.writeFile(wb, 'inventory_template.xlsx');
}

export function downloadInventoryUnitsTemplate() {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([
    [...INVENTORY_UNITS_TEMPLATE_HEADERS],
    ['Litebeam AC', 'LB-AC-001', 'CPE Radio', 'LBAC123456', 'Office', 'Shelf A', 'new', 'in stock', 'PO-1001', '', ''],
    ['LTU-LR', 'LTU-LR-001', 'CPE Radio', 'LTULR654321', 'Office', 'Van 1', 'used', 'checked out', 'JOB-44', 'James', 'On site'],
  ]);
  ws['!cols'] = UNITS_TEMPLATE_COLS;
  XLSX.utils.book_append_sheet(wb, ws, 'Inventory');
  XLSX.writeFile(wb, 'inventory_units_template.xlsx');
}

export function downloadInventoryExport(items: Item[], stockUnits: StockUnit[]) {
  const counts = new Map<string, number>();
  for (const unit of stockUnits) {
    counts.set(unit.itemId, (counts.get(unit.itemId) ?? 0) + 1);
  }

  const rows = [...items]
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
    .map(item => [
      item.name,
      item.sku ?? '',
      item.category ?? '',
      item.notes ?? '',
      counts.get(item.id) ?? 0,
    ]);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([[...INVENTORY_EXPORT_HEADERS], ...rows]);
  ws['!cols'] = EXPORT_COLS;
  XLSX.utils.book_append_sheet(wb, ws, 'Items');
  XLSX.writeFile(wb, 'inventory_export.xlsx');
}
